import { render, staticRenderFns } from "./ColorsComponents.vue?vue&type=template&id=86016078&"
import script from "./ColorsComponents.vue?vue&type=script&lang=js&"
export * from "./ColorsComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports